import {
  PERITADOR_UPDATE_VERIFIED_QUOTES_BEGIN,
  PERITADOR_UPDATE_VERIFIED_QUOTES_SUCCESS,
  PERITADOR_UPDATE_VERIFIED_QUOTES_FAILURE,
} from './constants'
import { REACT_APP_PERITADOR_API } from '../../../common/config'
import axios from 'axios'
import { toast } from 'react-toastify'

const DEFAULT_SUCCESS_TOAST = 'Guardaste los cambios correctamente'
const APPRAISAL_APPROVED_SUCCESS_TOAST = 'La tasación se aprobó con éxito'
const APPRAISAL_APPROVED_TOAST_KEY = 'appraisalApproved'

export const updateVerifiedQuotes = (id, body, options = {}) => {
  return async (dispatch) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: PERITADOR_UPDATE_VERIFIED_QUOTES_BEGIN,
    })

    try {
      const res = await axios.patch(`${REACT_APP_PERITADOR_API}/verifiedQuotes/${id}`, body)
      dispatch({
        type: PERITADOR_UPDATE_VERIFIED_QUOTES_SUCCESS,
        data: res.data,
        meta: options,
      })
      return res.data
    } catch (error) {
      dispatch({
        type: PERITADOR_UPDATE_VERIFIED_QUOTES_FAILURE,
        data: {error: error},
      })
      throw error
    }
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PERITADOR_UPDATE_VERIFIED_QUOTES_BEGIN:
      return {
        ...state,
        patchVerifiedQuotesPending: true,
        patchVerifiedQuotesError: null,
      }
    case PERITADOR_UPDATE_VERIFIED_QUOTES_SUCCESS: {
      const { successToast = DEFAULT_SUCCESS_TOAST, skipToast = false } = action.meta || {}

      if (!skipToast) {
        const toastMessage =
          successToast === APPRAISAL_APPROVED_TOAST_KEY
            ? APPRAISAL_APPROVED_SUCCESS_TOAST
            : successToast

        toast.success(toastMessage, {
          bodyClassName: 'react-toastify--success',
          className: 'react-toastify--success',
        })
      }

      return {
        ...state,
        patchVerifiedQuotesPending: false,
        patchVerifiedQuotesError: null,
        quotes: {
          ...state.quotes,
          appraisal:
            typeof action.data.appraisal === 'number'
              ? action.data.appraisal
              : state.quotes.appraisal,
          appraisal_approved:
            action.data.appraisal_approved !== undefined
              ? action.data.appraisal_approved
              : state.quotes.appraisal_approved,
          appraisal_observation:
            action.data.appraisal_observation !== undefined
              ? action.data.appraisal_observation
              : state.quotes.appraisal_observation,
        },
      }
    }
    case PERITADOR_UPDATE_VERIFIED_QUOTES_FAILURE:
      toast.error('Algo salió mal, intentá de nuevo en unos minutos.')
      return {
        ...state,
        patchVerifiedQuotesPending: false,
        patchVerifiedQuotesError: action.data.error,
      }
    default:
      return state
  }
}
